import { render, staticRenderFns } from "./ListaBookingsPage.vue?vue&type=template&id=b70b3da6"
import script from "./ListaBookingsPage.vue?vue&type=script&lang=js"
export * from "./ListaBookingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports